import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";

const PaymentOutcomeInfo = ({
  paymentStatus,
  paymentType,
  // accountNumber,
  // bankAccountName,
  paymentDate,
  tsPayLogo
}) => {

  const renderIconType = () => {
    return (paymentStatus === "pending" || paymentStatus === "paid") ? "check-circle" : "exclamation-circle";
  };

  const renderText = () => {
    return  paymentStatus === "pending" ? "deadlines.paymentOutcomePending"
					 : (paymentStatus === "paid" && paymentType === "payment") ? "deadlines.paymentOutcomeDone"
					 : (paymentStatus === "paid" && paymentType === "charge") ? "deadlines.paymentOutcomeCharged"
					 : "deadlines.paymentOutcomeFailed";
  };

  const valuesObject = () => {
    return paymentStatus === "pending" ? {
      // accountNumber: accountNumber,
      // bankAccountName: bankAccountName,
      paymentDate: moment(paymentDate).format(DATE_FORMAT_FOR_DISPLAY)
    }
      : paymentStatus === "paid" ? {
        paymentDate: moment(paymentDate).format(DATE_FORMAT_FOR_DISPLAY)
      }
        : {
          // accountNumber: accountNumber,
          // bankAccountName: bankAccountName,
        };
  };

  return (
    <div className="payment-outcome-container">
      <>
        <FontAwesomeIcon
          icon={["far", renderIconType()]}
          style={{margin: "4px 5px 0 0", color: paymentStatus === "paid" && "rgb(9, 130, 42)"}}
        />
        <p className="payment-outcome-text">
          <FormattedMessage id={renderText()}
            values={valuesObject()}
          />
        </p>
        {paymentStatus === "paid" &&
					<img className="payment-outcome-ts-pay-logo" src={tsPayLogo} alt="ts-pay-logo" />
        }
      </>
    </div>
  );
};

export default PaymentOutcomeInfo;

